import { render, staticRenderFns } from "./PotentialClient.vue?vue&type=template&id=aa7f3394&scoped=true&"
import script from "./PotentialClient.vue?vue&type=script&lang=js&"
export * from "./PotentialClient.vue?vue&type=script&lang=js&"
import style0 from "./PotentialClient.vue?vue&type=style&index=0&id=aa7f3394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7f3394",
  null
  
)

export default component.exports